import { useEffect, useState } from "react";
import { DeleteProduct, GetAllProductsWithImages, UpdateProductInfo } from "../services/ApiServices/ProductService";
import { Card, CardHeader, Typography, CardBody, IconButton, Tooltip, Button } from "@material-tailwind/react";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
import AdminAddProduct from "./AdminAddProduct";
import AdminEditProduct from "./AdminEditProduct";
import About from "../components/Pages/About";
import { DeleteProductSize } from "../services/ApiServices/ProductSize";

type ProductProps = {
    loading: boolean;
    setLoading: (loading: boolean) => void;
};

function AdminProduct({ loading, setLoading }: ProductProps) {
    const [products, setProducts] = useState<Product[]>([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [productIdToEdit, setProductIdToEdit] = useState<string | null>(null);

    const TABLE_HEAD = ["ID", "Tên", "Giá", "Số lượng", "Ghi chú", "Loại", "Chất liệu", "Trạng thái", ""];
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(!open);

    const handleOpenEdit = (id: string | null) => {
        console.log("open", id);
        setProductIdToEdit(id);
        setOpenEdit(!openEdit);
    };

    const handleDeleteProduct = async (product: any) => {
        setLoading(true);
        try {
            console.log(product)
            if (product.productSize && product.productSize.length > 0) {
                for (let size of product.productSize) {
                    await DeleteProductSize(size.id);
                }
            }
            await DeleteProduct(product.id);
            fetchProducts();
        } catch (error) {
            console.error("Error deleting product:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchProducts = () => {
        GetAllProductsWithImages()
            .then((data) => {
                setProducts(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching products:", error);
                setLoading(false);
            });
    };

    useEffect(() => {
        setLoading(true);
        fetchProducts();
    }, []);

    return (
        <Card placeholder={""} className="h-full w-full">
            <CardHeader placeholder={""} floated={false} shadow={false} className="rounded-none">
                <div className="mb-8 flex items-center gap-8 justify-between mt-3">
                    <div>
                        <Typography placeholder={""} variant="h2" color="blue-gray">
                            Danh sách sản phẩm
                        </Typography>
                        <Typography placeholder={""} color="gray" className="mt-1 font-normal">
                            Xem thông tin tất cả sản phẩm
                        </Typography>
                    </div>
                    <Button placeholder={""} onClick={handleOpen} className="flex items-center gap-3" size="sm">
                        <PlusIcon className="h-4 w-4" />
                        Thêm sản phẩm
                    </Button>
                    <AdminAddProduct setLoading={setLoading} open={open} handleOpen={handleOpen} fetchProducts={fetchProducts} />
                </div>
            </CardHeader>
            <CardBody placeholder={""} className="overflow-scroll px-0">
                <table className="mt-4 w-full min-w-max table-auto text-left">
                    <thead>
                        <tr>
                            {TABLE_HEAD.map((head) => (
                                <th key={head} className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4">
                                    <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                                        {head}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((product) => (
                            <tr key={product.id}>
                                <td className="p-4 border-b border-blue-gray-50">
                                    <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal underline">
                                        <Link to={`/AdminProductDetail/${product.id}`} className="hover:text-blue-500">
                                            {product.id}
                                        </Link>
                                    </Typography>
                                </td>
                                <td className="p-4 border-b border-blue-gray-50">
                                    <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                                        {product.name}
                                    </Typography>
                                </td>
                                <td className="p-4 border-b border-blue-gray-50">
                                    <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                                        {product.price}
                                    </Typography>
                                </td>
                                <td className="p-4 border-b border-blue-gray-50">
                                    <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                                        {product.quantity}
                                    </Typography>
                                </td>
                                <td className="p-4 border-b border-blue-gray-50">
                                    <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                                        {product.description}
                                    </Typography>
                                </td>
                                <td className="p-4 border-b border-blue-gray-50">
                                    <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                                        {product.type}
                                    </Typography>
                                </td>
                                <td className="p-4 border-b border-blue-gray-50">
                                    <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                                        {product.material}
                                    </Typography>
                                </td>
                                <td className="p-4 border-b border-blue-gray-50">
                                    <Typography placeholder={""} variant="small" color="blue-gray" className="font-normal">
                                        {product.status}
                                    </Typography>
                                </td>
                                <td className="p-4 border-b border-blue-gray-50">
                                    <div className="flex items-center gap-2">
                                        <Tooltip content="Edit Product">
                                            <IconButton placeholder={""} variant="text" onClick={() => handleOpenEdit(product.id)}>
                                                <PencilIcon className="h-4 w-4" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip content="Delete Product">
                                            <IconButton placeholder={""}
                                                onClick={() => handleDeleteProduct(product)}
                                                variant="text"
                                            >
                                                <TrashIcon className="h-4 w-4 text-red-500" />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </CardBody>
            <AdminEditProduct
                setLoading={setLoading}
                open={openEdit}
                handleOpen={() => handleOpenEdit(null)}
                fetchProducts={fetchProducts}
                productId={productIdToEdit}
            />
        </Card>
    );
}

export default AdminProduct;

type Product = {
    id: string;
    name: string;
    price: number;
    quantity: number;
    description: string;
    type: string;
    material: string;
    status: string;
    productImages: ProductImage[];
    productSizeId: string | null;
    createDate: Date;
};


type ProductImage = {
    imageUrl: string;
    productId: string;
};
